import { Input } from 'antd';
import cls from 'classnames';
import { useTranslation } from '@/hooks/useTranslation';
import commonStyles from '../common.module.less';
import styles from './index.module.less';

export type TSearchBarProps = {
  className?: string;
  onSearch?: (keyword: string) => void;
};

const SearchBar: React.FC<TSearchBarProps> = props => {
  const $ = useTranslation();
  const { className, onSearch } = props;

  // 关键词搜索
  const handleKeyWordSearch = (value: string) => {
    onSearch?.(value);
  };

  return (
    <div className={cls(commonStyles.card, styles.container, className)}>
      <div className={styles.searchBar}>
        <Input.Search
          placeholder={$('请输入关键词')}
          allowClear
          enterButton
          size='large'
          onSearch={handleKeyWordSearch}
          className={styles.searchInput}
        />
      </div>
    </div>
  );
};

export default SearchBar;
